import { useEffect, useRef, useState } from 'react'
import { useRecoilState } from 'recoil'
import { settingsState } from '@/store'
import { AlertCircle } from 'react-feather'
import Button from '@/components/Button'
import analytics from '@/utils/analytics'
import { useShowChatTabModal } from '@/components/Modal'
import { useRouter } from 'next/router'
import { isPremiumState } from '@/store'
import { hideChatWithTranscriptNewBadgeLocalStorageKey } from './ChatWithTranscriptTab'

export default function ChatWithTranscript({
  video,
  user,
  isVisible,
  setShowDemo,
  isDemo,
}) {
  const [iframeLoaded, setIframeLoaded] = useState(false)
  const iframeRef = useRef(null)
  const hasAlreadyShownModal = useRef(false)
  const hasAlreadySentInitMessage = useRef(false)
  const [isPremium] = useRecoilState(isPremiumState)
  const [settings] = useRecoilState(settingsState)
  const chatUrl = process.env.NEXT_PUBLIC_CHAT_ANNOTATE_URL
  const language = (settings && settings.transcriptLanguage) || 'en'
  const showNeedToUpgradeModal = useShowChatTabModal()
  const router = useRouter()
  const showPremiumMessage = !isPremium && isVisible

  useEffect(() => {
    if (showPremiumMessage && !hasAlreadyShownModal.current) {
      analytics.track('(Chat Tab) Not Premium')
      setShowDemo(false)
      showNeedToUpgradeModal(router)
      hasAlreadyShownModal.current = true
    }
  }, [showPremiumMessage, setShowDemo, showNeedToUpgradeModal, router])

  useEffect(() => {
    if (isVisible && !isDemo) {
      window.localStorage.setItem(
        hideChatWithTranscriptNewBadgeLocalStorageKey,
        'true'
      )
    }
  }, [isVisible, isDemo])

  useEffect(() => {
    if (!isVisible) {
      hasAlreadyShownModal.current = false
    }
  }, [isVisible])

  useEffect(() => {
    if (hasAlreadySentInitMessage.current || !isVisible || !iframeLoaded) {
      return
    }

    hasAlreadySentInitMessage.current = true

    const iframeEl = iframeRef.current

    if (iframeEl?.contentWindow?.location) {
      iframeEl.contentWindow.postMessage(
        { type: 'INIT_CHAT', video, user, language },
        chatUrl
      )
    }
  }, [isVisible, video, user, language, chatUrl, iframeLoaded])

  if (showPremiumMessage) {
    return (
      <div
        className="relative overflow-x-auto overflow-y-hidden bg-white p-3 h-full"
        style={{ border: '1px solid #e0e0e0' }}
      >
        <div className="relative overflow-y-auto h-full pt-2 scroll-mask">
          <div className="center h-full flex-col">
            <AlertCircle className="mb-3" />
            Chatting with a video transcript is a premium feature
            <Button
              className="mt-3"
              onClick={() => {
                analytics.track('(Chat Tab) Not Premium')
                setShowDemo(false)
                showNeedToUpgradeModal(router)
              }}
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="flex flex-col relative overflow-x-auto overflow-y-hidden bg-white p-3 flex-1"
      style={{
        border: '1px solid rgb(224, 224, 224)',
        display: isVisible ? 'flex' : 'none',
      }}
    >
      <div
        className="whitespace-pre-line -m-3"
        style={{ flex: '1', height: '100%' }}
      >
        <iframe
          ref={iframeRef}
          src={chatUrl}
          style={{ width: '100%', height: '100%', border: 'none' }}
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </div>
  )
}
